import { render, staticRenderFns } from "./fetchOverages.vue?vue&type=template&id=2677dfc9&scoped=true"
import script from "./fetchOverages.vue?vue&type=script&lang=js"
export * from "./fetchOverages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2677dfc9",
  null
  
)

export default component.exports